import React, { Component } from 'react';
import IncludedFeature from './Options/IncludedFeature';
class IncludedFeatures extends Component {
	render() {
		const { planFeature, accountInitialStatus } = this.props;
		
		return (
			<div className="plan-section">
				<h5>Included Features</h5>
				<div className="package-wrapper" data-package-wrapper-id="pl001-ifeat001">
					{planFeature.map((feature, index) => (<IncludedFeature feature={feature} key={index} accountInitialStatus={accountInitialStatus} />))}
				</div>
			</div>
		);
	}
}

export default IncludedFeatures;
